interface FilterIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function FilterIcon({ size = 16, color = "#EF0BB8", ...props }: FilterIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      {...props}
    >
      <path
        d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.73-4.8 5.75-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
        fill="currentColor"
      />
    </svg>
  );
} 